import Parameters from './Parameters';

export default Parameters;
